import React, { useEffect, useRef, useState } from "react";

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import Loader from "../Components/Common/Loader";

import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { AuthAPI } from "../Apis/authAPI";
import { useNavigate } from "react-router-dom";
import { useToastWrapper } from "../Wrapper/toastWrapper";

const Login = () => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  const { success, error } = useToastWrapper();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    if (email === "" || password === "") {
      error("Please enter email and password");
      setLoading(false);
      return;
    }

    if (email === "admin@admin.com") {
      if (password === "admin") {
        success("Login Success");
        sessionStorage.setItem("auth", "true");
        navigate("/admin/leads");
        setLoading(false);
        return;
      } else {
        error("Incorrect Password");
        setLoading(false);
        return;
      }
    } else {
      error("Incorrect Email");
      setLoading(false);
      return;
    }
  };

  const submitRef = useRef<any>(null);

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        submitRef.current.click();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <Flex
      w={"100vw"}
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
      direction={"column"}
    >
      {loading ? <Loader /> : null}
      <Box width={"400px"} shadow={"md"} p={10}>
        <Box>
          <Text
            fontWeight={"bold"}
            color={"primary.main"}
            fontSize={"32px"}
            textAlign={"center"}
          >
            Login
          </Text>
        </Box>
        <Box mt={"32px"}>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <InputGroup>
              <InputLeftElement h={"50px"} pointerEvents="none">
                {/* <Image src={Icons.LoginMail} alt="" /> */}
              </InputLeftElement>
              <Input
                h={"50px"}
                type="email"
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </InputGroup>
          </FormControl>
          <FormControl mt={"20px"}>
            <FormLabel>password</FormLabel>
            <InputGroup>
              <InputLeftElement h={"50px"} pointerEvents="none">
                {/* <Image src={Icons.LoginPassword} alt="" /> */}
              </InputLeftElement>
              <Input
                h={"50px"}
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <InputRightElement h={"50px"}>
                {showPassword ? (
                  <AiFillEyeInvisible
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowPassword(false);
                    }}
                  />
                ) : (
                  <AiFillEye
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowPassword(true);
                    }}
                  />
                )}
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <Button
            ref={submitRef}
            onClick={handleSubmit}
            mt={"30"}
            width={"full"}
            h={"60px"}
            alignItems={"center"}
            justifyContent={"center"}
            borderRadius={"16px"}
            display={"flex"}
            background={"primary.main"}
            color={"white"}
            _hover={{ background: "primary.main" }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Flex>
  );
};

export default Login;
